/**
 * Created by Andste on 2018/5/28.
 * 商品选择器,飞象项目使用
 * 依赖于element-ui
 */

import Vue from 'vue'
import ComboPicker from './src/main.vue'

ComboPicker.install = () => {
  Vue.component(ComboPicker.name, ComboPicker)
}

export default ComboPicker
